import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BusinessPage from './pages/BusinessPage';
import InspectionPage from './pages/InspectionPage';
import InfoPage from './pages/InfoPage';
import CustomerPage from './pages/CustomerPage';
import NewsPage from './pages/NewsPage';
import PolicyPage from './pages/PolicyPage';
import RecruitmentPage from './pages/RecruitmentPage';
import NotFound from './pages/NotFound';
import ErrorTestPage from './pages/ErrorTestPage';
import { navigationData } from './data';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Header navigationData={navigationData} />
          <main className="main-content">
            <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Company Routes - 안전원소개 */}
            <Route path="/company/about" element={<AboutPage subpage="about" />} />
            <Route path="/company/message" element={<AboutPage subpage="message" />} />
            <Route path="/company/vision" element={<AboutPage subpage="vision" />} />
            <Route path="/company/history" element={<AboutPage subpage="history" />} />
            <Route path="/company/org" element={<AboutPage subpage="org" />} />
            <Route path="/company/ci" element={<AboutPage subpage="ci" />} />
            <Route path="/company/contribution" element={<AboutPage subpage="contribution" />} />
            <Route path="/company/map" element={<AboutPage subpage="map" />} />

            {/* Business Routes - 주요사업 */}
            <Route path="/business/b1" element={<BusinessPage subpage="b1" />} />
            <Route path="/business/b2" element={<BusinessPage subpage="b2" />} />
            <Route path="/business/b3" element={<BusinessPage subpage="b3" />} />
            <Route path="/business/b4" element={<BusinessPage subpage="b4" />} />

            {/* Check Routes - 승강기 정기검사 */}
            <Route path="/check/c1" element={<InspectionPage subpage="c1" />} />
            <Route path="/check/c3" element={<InspectionPage subpage="c3" />} />

            {/* Info Routes - 승강기 생활/정보 */}
            <Route path="/law" element={<InfoPage subpage="law" />} />
            <Route path="/law1" element={<InfoPage subpage="law1" />} />
            <Route path="/law2" element={<InfoPage subpage="law2" />} />
            <Route path="/law3" element={<InfoPage subpage="law3" />} />
            <Route path="/law4" element={<InfoPage subpage="law4" />} />
            <Route path="/info/b4" element={<InfoPage subpage="b4" />} />
            <Route path="/info/b5" element={<InfoPage subpage="b5" />} />

            {/* Customer Service Routes - 고객서비스 */}
            <Route path="/cs/cs1" element={<CustomerPage subpage="cs1" />} />
            <Route path="/cs/cs4" element={<CustomerPage subpage="cs4" />} />
            <Route path="/variousform" element={<CustomerPage subpage="variousform" />} />
            <Route path="/qna" element={<CustomerPage subpage="qna" />} />
            <Route path="/communication" element={<CustomerPage subpage="communication" />} />

            {/* News Routes - 소식/홍보 */}
            <Route path="/notice" element={<NewsPage subpage="notice" />} />
            <Route path="/press" element={<NewsPage subpage="press" />} />
            <Route path="/announcement" element={<NewsPage subpage="announcement" />} />
            <Route path="/promotion" element={<NewsPage subpage="promotion" />} />
            <Route path="/companynotice" element={<NewsPage subpage="companynotice" />} />
            <Route path="/recruitment" element={<RecruitmentPage />} />

            {/* Policy Routes - 정책 페이지 */}
            <Route path="/policy/:type" element={<PolicyPage />} />

            {/* Test Route - ErrorBoundary 테스트 (개발 중에만 사용) */}
            <Route path="/test-error" element={<ErrorTestPage />} />

            {/* 404 Not Found - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
